import React from 'react'
import { gql, useQuery } from '@apollo/client'
import MutationsContext from './MutationsContext'
import capitalizeFirstLetter from '../helpers/capitalizeFirstLetter'

const SCHEMA = gql`
query schema {
  __schema {
    types {
      name
      kind
      inputFields {
        name
        type {
          kind
          name
          enumValues {
            name
            description
          }
          ofType {
            enumValues {
              name
              description
            }
            kind
            name
            ofType {
              kind
              name
            }
          }
        }
      }
      fields {
        name
        type {
          kind
          name
          enumValues {
            name
            description
          }
          ofType {
            enumValues {
              name
              description
            }
            kind
            name
            ofType {
              kind
              name
            }
          }
        }
      }
    }
  }
}
`
const getDataTypeAndEnumOptionsFromProperty = (type, depth) => {
  
  if (type === null || type === undefined || type.kind === undefined) {
    return null;
  }

  if (type.kind === "SCALAR") {
    return { name: type.name, enumValues: null, fields: null }
  }
  if (type.kind === "ENUM") {        
    if (type.enumValues == null) return null;        
    return { name: type.name,isEnum:true, enumValues: type.enumValues.map(x => x.name), fields: null }
  }
  if (type.kind === "OBJECT") {
    if (depth === 4) {
      console.log("TOO DEEP");
      return null;
    }
    return { name: "OBJECT", enumValues: null, fields: handleObjectPropertyFields(type, depth + 1) }
  }

  if (type.kind === "LIST") {
    const result = getDataTypeAndEnumOptionsFromProperty(type.ofType, depth + 1);
    if (result !== null) {
      result.name = result.name + "[]";
    }

    return result;
  }
  if (type.kind === "NON_NULL") {

    return getDataTypeAndEnumOptionsFromProperty(type.ofType, depth + 1)
  }
}
const handleObjectPropertyInputFields = (type, depth) => {
  const fields = [];
  if (!type || !type.inputFields) return;    
  for (let k = 0; k < type.inputFields.length; k++) {
    const dataType = getDataTypeAndEnumOptionsFromProperty(type.inputFields[k].type, depth);    
    if (dataType === null) continue;
    if (dataType.fields !== undefined) {
      fields.push({ propertyName: type.inputFields[k].name, dataType: dataType.name, enumValues: dataType.enumValues, fields: dataType.fields });
    }
    
  }
  return fields;
}
const handleObjectPropertyFields = (type, depth) => {
  const fields = [];
  if (!type || !type.fields) return;
  for (let k = 0; k < type.fields.length; k++) {
    const dataType = getDataTypeAndEnumOptionsFromProperty(type.fields[k].type, depth);
    if (dataType === null || dataType.name === "UUID") continue;
    if (dataType.fields !== undefined) {
      fields.push({ propertyName: type.fields[k].name, dataType: dataType.name, enumValues: dataType.enumValues, fields: dataType.fields });
    }
  }
  return fields;
}

const MutationProvider = ({ children }) => {

  const { data } = useQuery(SCHEMA)

  if (!data) return <></>

  const mutationDefinitions = [];

  const mutation = data.__schema.types.find(x => x.name === "Mutation");  
  for (let i = 0; i < mutation.fields.length; i++) {
    const mutationName=mutation.fields[i].name;
    const mutationInputName=capitalizeFirstLetter(mutationName)+"RequestInput";
    
    const mutationInputType = data.__schema.types.find(x => x.name === mutationInputName);            
    const properties = handleObjectPropertyInputFields(mutationInputType);        
    const createDefinition={
      typeName: mutation.fields[i].name,  
      definitions:properties,
    }
    mutationDefinitions.push(createDefinition);
  }
  return (
    <MutationsContext.Provider value={mutationDefinitions}>
      {children}
    </MutationsContext.Provider>
  )
}
export default MutationProvider
